import { useTranslation } from 'react-i18next';
import React from 'react';
import cx from 'clsx';
import { Router, Link } from '@reach/router';

import styles from '../ReviewAndPayment.module.scss';
import { useCart } from 'hooks/context/cart';
import { useMerchant } from 'hooks/context/merchant';
import { useServiceType } from 'hooks/context/serviceType';
import { useMerchantState } from 'hooks/context/MerchantState';
import { EditServiceTypeAndTimeModal } from 'routes/ServiceTypeAndTimeModal/ServiceTypeAndTimeModal';
import { CHECKOUT_TEST_ID } from '../../const';
import { useDelivery } from 'hooks/context/Delivery';
import { formatTimeForDelivery, timeFormat } from 'hooks/context/Delivery.util';
import { useScheduledOrderDisplay } from 'hooks/context/ScheduledOrderDisplay';
import { useRunningOrder } from 'hooks/context/RunningOrder';

export const Subheading: React.FC = () => {
  const { t } = useTranslation();
  const { merchant } = useMerchant();
  const { itemCount } = useCart();
  const runningOrder = useRunningOrder();
  const { currentServiceType, serviceTypes, tableDetails, isDelivery } = useServiceType();
  const { showDineInState, showScheduledOrderState } = useMerchantState();
  const { currentDate, currentTime } = useScheduledOrderDisplay();
  const { pickupTime, deliveryTime } = useDelivery();
  const hasScheduledOrder = currentDate && currentTime;
  const showEdit = (!showDineInState && serviceTypes.length > 1) || showScheduledOrderState;
  const timezone = merchant?.timezone || 'local';

  if ((itemCount === 0 && !runningOrder.hasItems) || !currentServiceType) return null;

  return (
    <span className={cx('p', styles.bold)} data-testid={ CHECKOUT_TEST_ID.leadtime }>
      {!hasScheduledOrder && isDelivery && (
        t('checkoutPage.subheading.delivery', {
          merchantName: merchant?.name,
          estimatedTime : t('checkoutPage.subheading.deliveryLeadTime', { leadTime: `${formatTimeForDelivery(pickupTime, merchant?.leadTime, timezone, timeFormat.simple)} - ${formatTimeForDelivery(deliveryTime, merchant?.leadTime, timezone, timeFormat.simple)}` }) })
      )}
      {!hasScheduledOrder && !isDelivery && (
        t(`checkoutPage.subheading.${currentServiceType.toLowerCase()}`, {
          table: tableDetails?.name ? t('checkoutPage.subheading.table_number', { tableNumber: tableDetails?.name }) : '',
          merchantName: merchant?.name,
          estimatedTime : t('checkoutPage.subheading.leadTime', {
          leadTime: merchant?.leadTime,
        }) })
      )}
      {hasScheduledOrder && (
        t(`checkoutPage.subheading.${currentServiceType.toLowerCase()}`, {
          merchantName: merchant?.name,
          estimatedTime : t('checkoutPage.subheading.scheduledOrder', {
          date: currentDate?.label,
          time: currentTime?.label
        }) })
      )}
    {showEdit && (
      <span>
        <Link to={'edit'} className={cx(styles.editButton)} data-testid={ CHECKOUT_TEST_ID.edit }>
          {t('edit')}
        </Link>
        <Router primary={false}>
          <EditServiceTypeAndTimeModal path="edit" />
        </Router>
      </span>
    )}
    </span>
  );
};
